// Identifies the domain resources touched by organization events, including
// resources carried as relationships instead of the event's primary subject.

// The schemas module is the leaf; importing the type from the hook drags
// its whole data-fetching graph in behind it.
import { type OrganizationEvent } from '@apps/web/hooks/organization_event_schemas';

export function organizationEventReferencesResource(
    event: OrganizationEvent,
    resourceType: OrganizationEvent['resource']['type'],
): boolean {
    return (
        event.resource.type === resourceType ||
        event.relationships.some(
            (relationship) => relationship.type === resourceType,
        )
    );
}

// v3 publishes these events against an `outreach` resource while v2 still
// publishes `callout`, so both spellings have to repaint.
export function organizationEventReferencesOutreach(
    event: OrganizationEvent,
    outreachId: string,
): boolean {
    return [event.resource, ...event.relationships].some(
        (resource) =>
            (resource.type === 'outreach' || resource.type === 'callout') &&
            resource.id === outreachId,
    );
}
